import { SHELL } from "@app/constants/paths/shell/shell.const";

const MY_ACCOUNT = 'mi-cuenta';
const MY_PROFILE = 'perfil';

const MY_BENEFIARYS_HOME = '' ;
const MY_BENEFIARYS = 'mis-beneficiarios';
const MY_BENEFIARYS_ADD = 'agregar-beneficiario';
const MY_BENEFIARYS_EDIT = 'editar-beneficiario';


export const MY_BENEFIARYS_ROUTES = {
    MY_BENEFIARYS,
    MY_BENEFIARYS_HOME,
    MY_BENEFIARYS_ADD,
    MY_BENEFIARYS_EDIT,

    /** /mi-cuenta/perfil/mis-beneficiarios */
    ROUTE_MY_BENEFIARYS_HOME: `${SHELL}/${MY_ACCOUNT}/${MY_PROFILE}/${MY_BENEFIARYS}`,
    /** /mi-cuenta/perfil/mis-beneficiarios/agregar */
    ROUTE_MY_BENEFIARYS_ADD:  `${SHELL}/${MY_ACCOUNT}/${MY_PROFILE}/${MY_BENEFIARYS}/${MY_BENEFIARYS_ADD}`,
    /** /mi-cuenta/perfil/mis-beneficiarios/editar */
    ROUTE_MY_BENEFIARYS_EDIT: `${SHELL}/${MY_ACCOUNT}/${MY_PROFILE}/${MY_BENEFIARYS}/${MY_BENEFIARYS_EDIT}`,


}
